
ParametersTagEditionController.$inject = ['$scope', 'ParametersFactory', 'tmhDynamicLocale', '$translate', '$stateParams', '$uibModalInstance', 'tag', 'actionType', 'company', 'loggedUser', 'group', 'groups'];
export function ParametersTagEditionController($scope, ParametersFactory, tmhDynamicLocale, $translate, $stateParams,
  $uibModalInstance, tag, actionType, company, loggedUser, group, groups) {
  init();
  $scope.getTagData = getTagData;
  $scope.addDependsUpon = addDependsUpon;
  $scope.setDependsUponTagGroup = setDependsUponTagGroup;
  $scope.setDependsUponTag = setDependsUponTag;
  $scope.deleteDependsUpon = deleteDependsUpon;

  function getTagData() {
    return {
      name_fr: $scope.nameFr,
      name_en: $scope.nameEn,
      name_es: $scope.nameEs,
      name_nl: $scope.nameNl,
      depends_upon : $scope.depends_upon
    };
  }

  function addDependsUpon() {
    let tag_id = groups[0].tags_and_categories.filter(i => !i.is_category)[0].id;
    $scope.depends_upon.push({tag_group_id : groups[0].id, tag_id: tag_id});
  }
  function setDependsUponTagGroup(depends_upon, tg) {
    depends_upon.tag_group_id = tg.id;
    depends_upon.tag_id = tg.tags_and_categories.filter(i => !i.is_category)[0].id;
  }
  function setDependsUponTag(depends_upon, tag) {
    depends_upon.tag_id = tag.id;
  }
  function deleteDependsUpon(depends_upon) {
    $scope.depends_upon = $scope.depends_upon.filter(i => i !== depends_upon);
  }

  function init() {
    $scope.isAddition = (actionType == 'addition') ? true : false;
    $scope.isEdition = (actionType == 'edition') ? true : false;
    $scope.myTagGroups = groups;
    $scope.myTagGroup = group;

    if (tag) {
      $scope.isNone = tag.id === group.none_tag.id;
      $scope.nameFr = tag.name_fr;
      $scope.nameEn = tag.name_en;
      $scope.nameEs = tag.name_es;
      $scope.nameNl = tag.name_nl;
      $scope.depends_upon = tag.depends_upon; 
    } else {
      $scope.nameFr = '';
      $scope.nameEn = '';
      $scope.nameEs = '';
      $scope.nameNl = '';
    }
    if (!$scope.depends_upon) {
      $scope.depends_upon = [];
    };
}

}
